// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { Route, Redirect } from 'react-router-dom'
import ImageryUpload from './pages/imagery-upload'
import ImageryUploadNew from './pages/imagery-upload-new'
import PageCameraManagement from './pages/camera-directory'
import React from 'react'
import {CameraOutlined, UploadOutlined} from '@ant-design/icons'
import { connect } from 'react-redux'
import PageProfile from './pages/PageProfile'
import Admin from 'pages/admin'
import UploadQueue from './pages/upload-queue/UploadQueue'
import GeneralSetting from 'pages/general-setting'
import InternalSetting from 'pages/internal-setting'
import DongleUpload from './pages/dongle-upload'

import Demo from 'components/map/CameraStatus'
export const parentRoutes = [
  {
    parent: 'Upload',
    parentID: 'Upload',
    icon: <UploadOutlined/>
  },
  {
    parent: 'Camera',
    parentID: 'Camera',
    icon: <CameraOutlined/>
  },
]
export const privateRoutes = [
  {
    path: '/demo',
    component: Demo,
    hideOnProd: true,
    name: 'Demo',
    roles: ['admin', 'operator'],
    parentID: null

  },
  {
    path: '/cameras',
    component: PageCameraManagement,
    name: 'Camera Directory',
    roles: ['admin', 'operator'],
    parentID: 'Camera',
  },
  {
    path: '/upload',
    name: 'Imagery Upload',
    parentID: 'Upload',
    component: ImageryUploadNew,
    roles: ['admin', 'operator']
  },
  {
    path: '/profile',
    component: PageProfile,
    name: 'Profile',
    parentID: null,
    roles: ['admin', 'operator']
  },
  {
    path: '/admin',
    component: Admin,
    name: 'Admin',
    roles: ['admin'],
    parentID: null
  },
  {
    path: '/uploadqueue',
    component: UploadQueue,
    name: 'Upload Queue',
    roles: ['admin', 'operator'],
    parentID: 'Upload',
  },
  // {
  //   path: '/dongleupload',
  //   hideOnProd: true,
  //   component: DongleUpload,
  //   name: 'Dongle Devices',
  //   parentID: 'Upload',
  //   roles: ['admin', 'operator']
  // },
  {
    path: '/setting',
    component: GeneralSetting,
    roles: ['admin', 'operator'],
    name: 'General Setting',
    parentID: 'Camera',
  },
  {
    path: '/internal-setting',
    component: InternalSetting,
    roles: ['admin'],
    name: 'Internal Setting',
    hideOnProd: false,
    parentID: null
  },
]
export const RouteWithSubRoutes = ({ path, component: Component }) => {
  return (
    <Route path={path}>
      <Component />
    </Route>
  )
}

export const RequireLoginRoute = connect(state => state.auth)(props => {
  if (!props.isAuthorized) {
    return <Redirect to='/login' />
  }
  return <Route {...props} />
})
